import React, { useEffect, useContext } from 'react';
import { Breadcrumbs, TextInput, TextArea, Button, FileMultipleUploader } from '../../components';
import { useForm } from '../../hooks';
import { useHistory } from 'react-router-dom';
import { UserContext, SnackbarContext } from '../../contexts';
import Handler from '../../Handler';
import API from '../../api';

export const MethodologyRequestPage = (props) => {
  const history = useHistory();
  const { userInfo } = useContext(UserContext);
  const { updateSnackbar } = useContext(SnackbarContext);
  const [formData, formMeta, formChange, setFormData, setFormMeta, formReset] = useForm(
    {
      email: '',
      name: '',
      phone: '',
      title: '',
      content: '',
      fileArray: [],
    },
    {
      email: {
        key: 'email',
        label: '이메일',
        disabled: true,
        style: {
          gridColumn: '1/3',
          maxWidth: '420px',
        },
      },
      name: {
        key: 'name',
        label: '이름',
        disabled: true,
      },
      phone: {
        key: 'phone',
        label: '휴대폰',
        disabled: true,
      },
      title: {
        key: 'title',
        label: '제목',
        style: {
          gridColumn: '1/3',
        },
        required: true,
      },
      content: {
        key: 'content',
        label: '상담 내용',
        maxSize: 500,
        style: {
          gridColumn: '1/3',
        },
        required: true,
      },
      fileArray: {
        key: 'fileArray',
        type: 'file',
        label: '첨부파일',
        subLabel: '첨부파일은 최대 10MB 가능합니다.',
        path: 'dummy',
        max: 10,
        style: {
          gridColumn: '1/3',
        },
      },
    },
  );

  useEffect(() => {
    if (userInfo) {
      setFormData({
        ...formData,
        email: userInfo.email,
        name: userInfo.name,
        phone: userInfo.phone,
      });
    }
  }, [userInfo]);

  const requsetSubmit = () => {
    console.log('requsetSubmit');

    let body = Handler.formToBody(formData, formMeta);
    if (body) {
      API.User.PostInquiry({ ...body, type: 'Methodology' }).then(
        (res) => {
          let result = res.data;
          console.log('User PostInquiry result', result);
          history.push('/request_complete?type=mypage');
        },
        (err) => {
          updateSnackbar({
            type: 'error',
            open: true,
            message: err.data.message,
          });
        },
      );
    } else {
      updateSnackbar({
        type: 'error',
        open: true,
        message: '필수정보를 확인해주세요.',
      });
    }
  };

  return (
    <article className='basic-page'>
      <Breadcrumbs content='methodology' title={'방법론 상담 신청'}></Breadcrumbs>
      <article className='content__wrapper'>
        <section className='guide-text__container'>
          <h1>방법론 등록을 준비하시나요?</h1>
          <h1 style={{ marginBottom: 10 }}>상담을 통해 도움을 받으실 수 있습니다.</h1>
          <span>상담을 신청하시면 담당자가 확인 후 연락을 드립니다.</span>
        </section>
        <section className='form__container'>
          <ul className='grid'>
            <TextInput value={formData.email} onChange={formChange} meta={formMeta.email}></TextInput>
            <TextInput value={formData.name} onChange={formChange} meta={formMeta.name}></TextInput>
            <TextInput value={formData.phone} onChange={formChange} meta={formMeta.phone}></TextInput>
            <TextInput value={formData.title} onChange={formChange} meta={formMeta.title}></TextInput>
            <TextArea value={formData.content} onChange={formChange} meta={formMeta.content}></TextArea>
            <FileMultipleUploader
              value={formData.fileArray}
              onChange={formChange}
              meta={formMeta.fileArray}
            ></FileMultipleUploader>
          </ul>
        </section>
        <div className='border-grey-200'></div>

        <section className='button__container'>
          <Button style={{ width: '240px' }} onClick={requsetSubmit} label='상담신청'></Button>
        </section>
      </article>
    </article>
  );
};
